import Cookies from 'universal-cookie'
import getConfig from 'next/config'
import Axios from 'axios'

const cookies = new Cookies()
const { publicRuntimeConfig } = getConfig()

// getter
const getPdpaCookies = (isLogin) => {
  const prefix = isLogin
    ? publicRuntimeConfig.shpLoginPdpa
    : publicRuntimeConfig.shpNoneLoginPdpa
  const isSetPdpa =
    cookies.get(`${prefix}_${publicRuntimeConfig.isSetPdpa}`) === 'true'
  if (!isSetPdpa) return false
  const targeting =
    cookies.get(`${prefix}_${publicRuntimeConfig.targetingCookies}`) === 'true'
  const functionality =
    cookies.get(`${prefix}_${publicRuntimeConfig.functionalityCookies}`) ===
    'true'
  const performance =
    cookies.get(`${prefix}_${publicRuntimeConfig.performanceCookies}`) ===
    'true'
  return {
    targeting,
    functionality,
    performance,
  }
}

const getPdpaLocalStorage = () => {
  if (!localStorage.getItem('shp_user')) return false
  const userData = JSON.parse(localStorage.getItem('shp_user'))
  const pdpa = userData.user?.member_consens_pdpa?.pdpa
  if (!pdpa) return false
  return {
    targeting: pdpa.TARGETING_COOKIE,
    functionality: pdpa.FUCIONALITY_COOKIE,
    performance: pdpa.PERFORMANCE_COOKIE,
  }
}

const getPdpaByPriority = () => {
  let result = null
  result = getPdpaLocalStorage()
  if (result) return { ...result, isSet: true }
  result = getPdpaCookies(true)
  if (result) return { ...result, isSet: true }
  result = getPdpaCookies(false)
  if (result) return { ...result, isSet: true }
  return {
    performance: false,
    targeting: false,
    functionality: false,
    isSet: false,
  }
}

// setter
const setPdpaCookies = (isLogin, { targeting, functionality, performance }) => {
  if (isLogin) {
    const prefix = publicRuntimeConfig.shpLoginPdpa
    cookies.set(`${prefix}_${publicRuntimeConfig.isSetPdpa}`, true)
    cookies.set(`${prefix}_${publicRuntimeConfig.targetingCookies}`, targeting)
    cookies.set(
      `${prefix}_${publicRuntimeConfig.functionalityCookies}`,
      functionality
    )
    cookies.set(
      `${prefix}_${publicRuntimeConfig.performanceCookies}`,
      performance
    )
  } else {
    const prefix = publicRuntimeConfig.shpNoneLoginPdpa
    cookies.set(`${prefix}_${publicRuntimeConfig.isSetPdpa}`, true)
    cookies.set(`${prefix}_${publicRuntimeConfig.targetingCookies}`, targeting)
    cookies.set(
      `${prefix}_${publicRuntimeConfig.functionalityCookies}`,
      functionality
    )
    cookies.set(
      `${prefix}_${publicRuntimeConfig.performanceCookies}`,
      performance
    )
  }
}

const updatePdpaMemberService = async ({
  targeting,
  functionality,
  performance,
}) => {
  if (!localStorage.getItem('shp_user')) return false // error shp_user not found (should never happen)
  const shpUser = JSON.parse(localStorage.getItem('shp_user'))
  if (!shpUser?.user) return false // error user in shp_user not found (should not happen)

  const httpMethod = shpUser.user.member_consens_pdpa?.id ? 'patch' : 'post'
  try {
    const res = await Axios.post('/api/member/set-pdpa', {
      pdpa: {
        PERFORMANCE_COOKIE: performance,
        FUCIONALITY_COOKIE: functionality,
        TARGETING_COOKIE: targeting,
      },
      userId: shpUser.user.id,
      method: httpMethod,
    })
    if (res) return { status: 'success', res: res.data }
  } catch (err) {
    if (err.response) {
      switch (err.response.data.message) {
        case 'bad request':
          return { status: 'error', message: 'bad request' }
        case 'member does not exist':
          return { status: 'error', message: 'member does not exist' }
        default:
          return { status: 'error', message: err.response.data.message }
      }
    } else return { status: 'error', message: err.message }
  }
}

const setPdpaLocalStorage = ({ targeting, functionality, performance }) => {
  if (!localStorage.getItem('shp_user')) return false
  const userData = JSON.parse(localStorage.getItem('shp_user'))
  const user = userData?.user
  if (!user) return false
  const newMemberConcensPdpa = {
    pdpa: {
      PERFORMANCE_COOKIE: targeting,
      FUCIONALITY_COOKIE: functionality,
      TARGETING_COOKIE: performance,
    },
  }
  const newUser = {
    ...user,
    member_consens_pdpa: newMemberConcensPdpa,
  }
  const newUserData = {
    ...userData,
    user: newUser,
  }
  localStorage.setItem('shp_user', JSON.stringify(newUserData))
  return true
}

const clearAllLoginCookies = () => {
  const prefixLogin = publicRuntimeConfig.shpLoginPdpa
  cookies.remove(`${prefixLogin}_${publicRuntimeConfig.isSetPdpa}`)
  cookies.remove(`${prefixLogin}_${publicRuntimeConfig.targetingCookies}`)
  cookies.remove(`${prefixLogin}_${publicRuntimeConfig.functionalityCookies}`)
  cookies.remove(`${prefixLogin}_${publicRuntimeConfig.performanceCookies}`)
}

export default {
  getPdpaCookies,
  getPdpaLocalStorage,
  setPdpaCookies,
  updatePdpaMemberService,
  setPdpaLocalStorage,
  clearAllLoginCookies,
  getPdpaByPriority,
}
